export const formatCurrency = (value) => {

  const initialValue = value ?? 0;
  // Remove all non-numeric characters
  const numericValue = initialValue.toString().replace(/\D/g, "");
  // Format with commas as thousand separators
  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};